import { gql } from 'graphql-request';

export const UPDATE_OPERATION_QUERY = gql`
  mutation UpdateOperation(
    $uuid: ID!
    $clientId: ID
    $teamNanoId: NanoId
    $subject: String
    $body: String
    $date: DateTime
    $completeDatetime: DateTime
    $operationType: String
    $state: String
    $fileAttachmentIds: [ID!]
  ) {
    updateOperation(
      input: {
        uuid: $uuid
        clientId: $clientId
        teamNanoId: $teamNanoId
        subject: $subject
        body: $body
        date: $date
        completeDatetime: $completeDatetime
        operationType: $operationType
        state: $state
        fileAttachmentIds: $fileAttachmentIds
      }
    ) {
      status
      recordUuid
      record {
        id
        uuid
      }
      errors {
        fullMessages
      }
    }
  }
`;
